import axios from 'axios'
import { Message } from 'element-ui'
import defaultSettings from '@/settings'
import { getToken, getRequestSignature, getAccessSignature } from '@/utils/auth'

const service = axios.create({
  baseURL: '/api',
  withCredentials: true,
  timeout: 5000
})
service.interceptors.request.use(
  config => {
    let timestamp = Date.parse(new Date())
    config.headers['App-Id'] = defaultSettings.appid
    config.headers['Timestamp'] = timestamp
    config.headers['Request-Signature'] = getRequestSignature(timestamp)
    const acctoken = getToken()
    if (acctoken) {
      const reqparams = {}
      if (config.method === 'post') {
        if (config.data) {
          config.data.forEach((val, key) => {
            reqparams[key] = val
          })
        }
      } else {
        if (config.params) {
          config.params.forEach((val, key) => {
            reqparams[key] = val
          })
        }
      }
      config.headers['Access-Token'] = acctoken
      config.headers['Access-Signature'] = getAccessSignature(reqparams, timestamp)
    }
    return config
  },
  error => {
    console.log(error) // for debug
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.data.errno === undefined) {
      console.log('错误接口信息', response.data)
      alert('接口错误')
    }
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (parseInt(res.errno) > 0) {
      Message({
        message: res.errmsg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js